import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TakedMedicationAddComponent } from './taked-medication-add.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '../../../../shared/translate/translate.module';

@NgModule({
  declarations: [TakedMedicationAddComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    // MatExpansionModule
  ],
  exports: [TakedMedicationAddComponent]
})
export class TakedMedicationAddModule { }
